import { CLIENT_FORGOT_USERID, CLIENT_FORGOT_USERID_ERROR, CLIENT_FORGOT_USERID_HIDE_ERROR, CLIENT_FORGOT_USERID_START_LOADER, CLIENT_FORGOT_USERID_STOP_LOADER, } from "../interface/IClientForgotUserID";
const initState = {
    data: {
        message: "",
        success: false,
    },
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const ClientForgotUserID = (state = initState, action) => {
    switch (action.type) {
        case CLIENT_FORGOT_USERID: {
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        }
        case CLIENT_FORGOT_USERID_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case CLIENT_FORGOT_USERID_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case CLIENT_FORGOT_USERID_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case CLIENT_FORGOT_USERID_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default ClientForgotUserID;
